var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-main page-container"},[_c('header-band',{attrs:{"title":_vm.$t('login_email_web_header'),"blueCleanfox":true,"back":true},on:{"eventBack":_vm.back}}),_c('login',{attrs:{"emailProps":_vm.loginEmail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }